module.exports = __webpack_public_path__ + "static/media/pontoz.db6f84cc.png";